import {useGoogleLogin} from "@react-oauth/google";
import gLogo from "./../../images/login/g.svg";

export default function GoogleLoginButton({children, className, onSuccess, onError}) {
    let handleSuccess = (response) => {
        onSuccess(response.code);
    };

    let handleError = (error) => {
        onError(error.error);
    };

    const googleAuth = useGoogleLogin({
        onSuccess: handleSuccess,
        onError: handleError,
        redirect_uri: import.meta.env.VITE_AUTHORITY_URL,
        scope: 'email',
        flow: 'auth-code',
    });


    let handleClick = () => {
        googleAuth();
    };

    return (
        <div
            className={'social-login-btn google'}
            onClick={() => handleClick()}
        >
            <img src={gLogo} alt="Facebook" className="h-[20px] w-[20px]"/>
            {children}
        </div>
    );
}
